export const getMicroAppPathAfterBase = (baseUrl: string) => {
  const { pathname, search } = window.location
  const normalizedPath = pathname.startsWith('/') ? pathname.slice(1) : pathname
  const rest = normalizedPath.slice(normalizedPath.indexOf(baseUrl) + baseUrl.length)

  return rest + search || '/'
}

export const trimUrl = (url: string) => {
  const withoutStart = url.startsWith('/') ? url.slice(1) : url
  const withoutStartAndEnd = withoutStart.endsWith('/') ? url.slice(0, -1) : withoutStart
  return withoutStartAndEnd
}
